<h1 mat-dialog-title class="dialog-title-with-action">
    {{ dialogTitle }}
</h1>
<mat-dialog-content>
    <div>
        <mat-card class="profile-card" *ngIf="currentUser$ | async as currentUser" layout-padding>
            <div fxLayout="column" fxFlex>
                <mat-form-field>
                    <mat-label>Name</mat-label>
                    <input matInput disabled [value]="currentUser.givenName + ' ' + currentUser.familyName" />
                </mat-form-field>

                <mat-form-field>
                    <mat-label>Email</mat-label>
                    <input matInput disabled [value]="currentUser.email" />
                </mat-form-field>

                <fieldset class="timesheet-fieldset">
                    <legend>Preferences</legend>
                    <div class="preferences-checkbox">
                        <mat-checkbox
                            style="margin-left: 25px; margin-top: 10px"
                            [checked]="profilePreferences && profilePreferences.showDetailColumnForTimecards"
                            (change)="showDetailColumn($event.checked)"
                            aria-label="Checkbox OptionShowDetailColumnForTimecards">
                            Show detail column for timecard views
                        </mat-checkbox>
                        <mat-checkbox
                            style="margin-left: 25px; margin-top: 10px"
                            [checked]="profilePreferences && profilePreferences.showArchivedData"
                            (change)="showArchivedData($event.checked)"
                            aria-label="Checkbox OptionShowArchivedData">
                            Show archived names in clients, projects, employees<br />
                            <small><i>(logged hours are not hidden in timecards nor timesheets)</i></small>
                        </mat-checkbox>
                    </div>
                </fieldset>
            </div>
        </mat-card>
    </div>
</mat-dialog-content>
<mat-dialog-actions class="profile-actions" fxLayoutAlign="end center" style="padding-left: 0">
    <div fxLayout="row" fxFill fxLayoutAlign="end">
        <button mat-button class="mat-raised-button" aria-label="cancel" fxFlex="20" (click)="closeDialog()">
            <span translate>Cancel</span>
        </button>
        <button
            mat-raised-button
            color="primary"
            [disabled]="!hasChanges"
            (click)="execute()"
            aria-label="execute"
            fxFlex="20">
            <span>Update</span>
        </button>
    </div>
</mat-dialog-actions>
